import storage from './internal/configStorage'
export default storage({})


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/reducers.js